"use client";
import React, { useEffect } from "react";
import ChevronUpIcon from "@/components/icons/ChevronUpIcon";

export default function ScrollButton() {
	useEffect(() => {
		const scroll_button = document.getElementById("nperp_scroll");

		const handleScroll = () => {
			if (scroll_button) {
				if (window.scrollY > 1.5 * window.innerHeight) {
					scroll_button.classList.add("nperp_scroll--show");
				} else {
					scroll_button.classList.remove("nperp_scroll--show");
				}
			}
		};

		window.addEventListener("scroll", handleScroll);
	}, []);
	return (
		<button
			id="nperp_scroll"
			className="nperp_scroll flex justify-center items-center bg-[#f6e9e9] border border-[#f6e9e9] rounded-[100%] cursor-pointer outline-none relative wrapper"
			onClick={() => {
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				});
			}}>
			<ChevronUpIcon />
		</button>
	);
}
